module.exports = __webpack_public_path__ + "images/ic-avatar-unassigned@2x-e8678cfa1b2d0e6429fda19b0c312683.png";